{
  "rules": [
    {
      "index": 1,
      "text": "Ikke lån mer. Fiks gjelden du allerede har."
    },
    {
      "index": 2,
      "text": "Forbrukslån og kredittkort har høy rente. Betal ned disse lånene først"
    },
    {
      "index": 3,
      "text": "<strong>Få oversikt over din gjeld</strong>"
    },
    {
      "index": 4,
      "text": "<strong>Sjekk ofte om du kan få lavere rente</strong>"
    },
    {
      "index": 5,
      "text": "<strong>Det er ingen skam å snu. Bytt dersom du får tilbud om lavere rente</strong>"
    },
    {
      "index": 6,
      "text": "Ta høyde for renteøkning og inntektsfall"
    },
    {
      "index": 7,
      "text": "Gjør små ekstra innbetalinger dersom du har mulighet"
    }
  ]
}
